import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef, useState } from 'react';
import useStoreItemClick from 'src/modules/parkplusStoreV2/hooks/useStoreItemClick';
import {
  trackCtaClickedStoreV2,
  trackProductViewedStoreV2,
  trackSectionViewedStoreV2,
} from 'src/modules/parkplusStoreV2/utils/events';
import { Button } from 'ui-v2/components/Button';
import { LayoutEntityType, LayoutPropType } from '../../../types/layout';
import WeekendCard from '../../Cards/WeekendCard';
import s from './WeekendListing.module.scss';
import Icon from 'ui-v2/components/Icon/Icon';
import dynamic from 'next/dynamic';

const Swiper = dynamic(() => import('core-lib/components/Swiper'), {
  ssr: false,
});

export const WeekendListing = ({ data }: LayoutPropType) => {
  const { handleItemClickWithDelegation, handleItemClick } =
    useStoreItemClick();

  const [activeIndex, setActiveIndex] = useState<number>(0);

  const CARDID = 'WEEKEND';
  //for event
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 1,
  });

  const swiperRef = useRef({});

  useEffect(() => {
    if (inViewPort) {
      if (!isEventFired.current) {
        trackSectionViewedStoreV2(data?.title);
        isEventFired.current = true;
      }
      const product = data?.data?.[activeIndex];
      if (product && !swiperRef.current[product?.productId]) {
        trackProductViewedStoreV2('weekend_listing', product?.productId, {
          description: product.eventType,
        });
        swiperRef.current[product?.productId] = true;
      }
    }
  }, [data, activeIndex, inViewPort]);

  return (
    <div
      ref={rootRef}
      className={s.root}
      style={{
        backgroundImage: `url(${data?.backgroundImage})`,
      }}
      onClick={(e) =>
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType,
          data?.data,
          data?.title
        )
      }
    >
      <div className={s.container}>
        <div className={s.carousel}>
          <Swiper
            effect="creative"
            onSlideChange={(el) => {
              setActiveIndex(el.realIndex);
            }}
            creativeEffect={{
              prev: {
                translate: ['-100%', 0, 0],
                scale: 0.9,
              },
              next: {
                translate: ['100%', 0, 0],
                scale: 0.9,
              },
            }}
            slidesPerView={1.5}
            centeredSlides
            spaceBetween={10}
            loop={true}
            slides={data?.data
              ?.filter((item) => item?.stock > 0)
              .map((item, id) => (
                <div key={item?.productSku}>
                  <WeekendCard
                    product={item}
                    section={data?.title}
                    position={id}
                    showNudge={false}
                    id={CARDID}
                  />
                </div>
              ))}
          />
        </div>
      </div>

      {data?.metaData?.categories?.[0] && (
        <div className={s.viewAll}>
          <Button
            variant="link_color"
            underline
            label="View all products"
            size="medium"
            rightIcon={
              <Icon name="ChevronRightRegular" color="brand" width={16} height={16} />
            }
            style={{
              marginTop: `16px`,
            }}
            onClick={() => {
              trackCtaClickedStoreV2(data?.title, 'view_all_products');
              const activeCat = data?.metaData?.categories?.[0];
              handleItemClick(
                LayoutEntityType.Category,
                activeCat?.productId,
                activeCat?.filter
              );
            }}
          />
        </div>
      )}
    </div>
  );
};
